/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUser200ResponseNotifications
 */
export interface GetUser200ResponseNotifications {
    /**
     * 
     */
    general?: boolean;
    /**
     * 
     */
    ioa?: boolean;
    /**
     * 
     */
    critical?: boolean;
    /**
     * 
     */
    high?: boolean;
    /**
     * 
     */
    medium?: boolean;
    /**
     * 
     */
    low?: boolean;
    /**
     * 
     */
    info?: boolean;
    /**
     * 
     */
    quickcheck?: boolean;
}

/**
 * Check if a given object implements the GetUser200ResponseNotifications interface.
 */
export function instanceOfGetUser200ResponseNotifications(value: object): value is GetUser200ResponseNotifications {
    return true;
}

export function GetUser200ResponseNotificationsFromJSON(json: any): GetUser200ResponseNotifications {
    return GetUser200ResponseNotificationsFromJSONTyped(json, false);
}

export function GetUser200ResponseNotificationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUser200ResponseNotifications {
    if (json == null) {
        return json;
    }
    return {
        
        'general': json['general'] == null ? undefined : json['general'],
        'ioa': json['ioa'] == null ? undefined : json['ioa'],
        'critical': json['critical'] == null ? undefined : json['critical'],
        'high': json['high'] == null ? undefined : json['high'],
        'medium': json['medium'] == null ? undefined : json['medium'],
        'low': json['low'] == null ? undefined : json['low'],
        'info': json['info'] == null ? undefined : json['info'],
        'quickcheck': json['quickcheck'] == null ? undefined : json['quickcheck'],
    };
}

export function GetUser200ResponseNotificationsToJSON(json: any): GetUser200ResponseNotifications {
    return GetUser200ResponseNotificationsToJSONTyped(json, false);
}

export function GetUser200ResponseNotificationsToJSONTyped(value?: GetUser200ResponseNotifications | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'general': value['general'],
        'ioa': value['ioa'],
        'critical': value['critical'],
        'high': value['high'],
        'medium': value['medium'],
        'low': value['low'],
        'info': value['info'],
        'quickcheck': value['quickcheck'],
    };
}

